namespace TabAurous.ProductDevelopment {
    export namespace PDQuotationLaborService {
        export const baseUrl = 'ProductDevelopment/QuotationLabor';

        export declare function Create(request: Serenity.SaveRequest<PDQuotationLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PDQuotationLaborRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PDQuotationLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PDQuotationLaborRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/QuotationLabor/Create",
            Update = "ProductDevelopment/QuotationLabor/Update",
            Delete = "ProductDevelopment/QuotationLabor/Delete",
            Retrieve = "ProductDevelopment/QuotationLabor/Retrieve",
            List = "ProductDevelopment/QuotationLabor/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PDQuotationLaborService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
